import { Routes, Route } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';

const IndexRoutes = () => {
  return (
    <Routes>
      {publicRoutes.map(({ path, component }, i) => (
        <Route key={i} path={path} element={component} />
      ))}

      {authProtectedRoutes.map(({ path, component }, i) => (
        <Route
          key={i}
          path={path}
          element={component}
        />
      ))}
    </Routes>
  );
};

export default IndexRoutes;